import * as React from 'react'
import { useContext } from 'react'
import { ChatMessageDirection } from 'src/graphql.generated'
import { LessonPreview, Message, ResponsePreview } from 'src/message'
import MessageBubble from 'src/message/MessageBubble'
import { EditMessageContext } from 'src/feed/EditChatMessage/EditMessageProvider'
import { CardActionsMenu } from 'src/designSystem'
import useMarkAsUnreadAction from '../useMarkAsUnreadAction'
import useCheckMessageEditable from '../EditChatMessage/useCheckMessageEditable'
import { FeedChatMessageItemFragment } from '../feedQueries.generated'
import { getMessageDisplayingProps } from './getMessageDisplayingProps'

type ChatMessageItemProps = {
  chatMessage: FeedChatMessageItemFragment
}

export default function ChatMessageItem({ chatMessage }: ChatMessageItemProps) {
  const { text, chatMessageDirection, messageID, coachID, feedID, createdAt, linkedResponse, linkedLesson } =
    chatMessage
  const isCareteamMessage = chatMessageDirection === ChatMessageDirection.ToPatient
  const { bubblePaletteColor, direction } = getMessageDisplayingProps(isCareteamMessage)
  const cleanedText = (text || '').trimLeft()
  const { startEditingMessage } = useContext(EditMessageContext)
  const markAsUnreadAction = useMarkAsUnreadAction(createdAt, 'chat_message')
  const [showEdit, setShowEdit] = React.useState(false)

  useCheckMessageEditable(createdAt, (newEnough) => {
    setShowEdit(newEnough && isCareteamMessage)
  })

  const actionItems = [
    ...(showEdit ? [{ label: 'Edit', onClick: () => startEditingMessage({ uid: feedID, ...chatMessage }) }] : []),
    ...(!isCareteamMessage ? [markAsUnreadAction] : []),
  ]
  const actions = actionItems.length > 0 && <CardActionsMenu actions={actionItems} />

  const renderLinkedTo = () => {
    if (linkedResponse) {
      return <ResponsePreview response={linkedResponse} />
    }
    if (linkedLesson) {
      return <LessonPreview lesson={linkedLesson} />
    }
    return undefined
  }

  return (
    <Message
      message={{
        id: messageID,
        authorID: coachID || feedID,
        createdAt: createdAt.valueOf(),
      }}
      direction={direction}
      actions={actions}
    >
      <MessageBubble bubblePaletteColor={bubblePaletteColor} linkedTo={renderLinkedTo()}>
        {cleanedText}
      </MessageBubble>
    </Message>
  )
}
